(function () {
    'use strict';

    angular.module('AngularAdmin')

        .factory('SupplierSvc', ['$http', function ($http) {
            var supplierSvc = {
                list: function () {
                    var url = '/suppliers/';

                    return $http.get(url, {});
                }
            };
            return supplierSvc;
        }]);
})();